module.exports = __webpack_public_path__ + "img/source_main-tit.dd7c41b4.png";